<template>
    <div class="modal fade" id="modal_attched_pointeuses_member" tabindex="-1" data-bs-backdrop="static"
        aria-hidden="true">
        <div v-if="requestAttachDetachMember" class="modal-dialog modal-lg">
            <div class="modal-content position-relative">
                <loader-gif v-if="isRequestMember" />
                <div class="modal-header">
                    <h5 class="modal-title" id="varyingModalLabel">
                        Donner l’accès à la pointeuse
                    </h5>
                    <button @click="closeModal('modal_attched_pointeuses_member', 'edit')" type="button"
                        class="btn-close" aria-label="btn-close"></button>
                </div>
                <div class="modal-body" v-if="requestAttachDetachMember">
                    <form class="forms-sample" @submit.prevent="submitForm">


                        <div class="row">
                            <div v-if="hasPermission('affected_pointeuses_to_member')" class="col-md-12">
                                <MultipSelect :TextLabel="i18n.t('tables.subscription_member.access')" :trackby="`id`"
                                    :label="`name`" :valueProp="`id`" v-model="requestAttachDetachMember.devices"
                                    :placeholder="i18n.t('tables.subscription_member.access')"
                                    :arrayOptions="pointeusesList" refs="pointeuses" :v="v$.pointeuses" />
                            </div>

                            <div class="col-md-6 text-right">
                                <button type="button" @click="closeModal('modal_attched_pointeuses_member', 'edit')"
                                    class="w-100 btn btn-cancel">
                                    {{ i18n.t("button.close") }}
                                </button>
                            </div>
                            <div class="col-md-6 text-right">
                                <button type="submit" class="w-100 btn btn-primary mr-2">
                                    {{ i18n.t("button.edit") }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Swal from "sweetalert2";
import i18n from "@/i18n/index";
import { defineComponent, ref, computed, watch, toRefs } from "vue";
/*Components*/
import MultipSelect from "@/components/inputsValidation/MultipSelect.vue";

/*composables & states */
import { useModal } from "@/composables/modal/useModal";
import { useMember } from "@/composables/member/useMember";
import { AttachedPointeusesToMemberRequest } from "@/interfaces/member";

import { fiche_member, pointeuses } from "@/shared/state";
import { usePermission } from "@/composables/auth/usePermission";
import { useVuelidate } from "@vuelidate/core";

export default defineComponent({
    components: {
        MultipSelect,
    },
    name: "attach-member-with-pointeuses-modal",
    props: {
        member: {
            type: Object,
            default: null,
        },
    },
    setup(props) {
        const APP_URL = process.env.VUE_APP_URL;
        const { member } = toRefs(props);
        const fiche_memberList = computed(() => fiche_member.data);
        const pointeusesList = computed(() => pointeuses.data);
        const { closeModal } = useModal();
        const { hasPermission } = usePermission();
        const action = ref("add");
        const isCaputre = ref<any>(0);

        const requestAttachDetachMember = ref<AttachedPointeusesToMemberRequest>({
            type: "attach",
            memberUUID: null,
            devices: [],
        });

        watch(
            () => member.value,
            (newValue) => {
                initState(member.value);
            }
        );

        const { AttachDetachPointeusesToMember, isRequestMember, errorMember } = useMember();

        // Validation
        const rules = {
            devices: {},
        };
        const v$ = useVuelidate(rules, requestAttachDetachMember, { $scope: "members" });

        /**
         * edit or edit member
         */
        const submitForm = async () => {
            v$.value.$touch();
            if (!v$.value.$invalid) {
                Swal.fire({
                    title: i18n.t("message.confirmation.edit.title"),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: i18n.t("button.edit"),
                    cancelButtonText: i18n.t("button.cancel"),
                    allowOutsideClick: false, // ✅ disable closing by clicking outside
                    allowEscapeKey: false, // (optional) disable closing with ESC
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        requestAttachDetachMember.value.memberUUID = fiche_member?.data?.member_info?.uuid || null;
                        await AttachDetachPointeusesToMember(requestAttachDetachMember.value)
                            .then((res) => {
                                if (fiche_member?.data?.member_info) {
                                    fiche_member.data.member_info = res.data || {};
                                    initState(fiche_member.data);
                                    if (!errorMember.value) {
                                        closeModal("modal_attched_pointeuses_member", "edit");
                                        location.reload();
                                    }
                                }
                            })
                            .catch((e) => { console.log(e); });
                    }
                });
            }
        };
        const initState = (member) => {
            action.value = "add";
            requestAttachDetachMember.value.memberUUID = member?.uuid || null;
            // requestAttachDetachMember.value.devices = member?.pointeuses || null;
            v$.value.$reset();
        };

        watch(
            pointeusesList,
            (list) => {
                if (
                    list?.length === 1 &&
                    (!requestAttachDetachMember.value.devices || requestAttachDetachMember.value.devices.length === 0)
                ) {
                    requestAttachDetachMember.value.devices = [list[0]]; // or [list[0]]
                }
            },
            { immediate: true }
        );

        return {
            /**
             * States
             */
            fiche_memberList,
            requestAttachDetachMember,

            submitForm,
            initState,
            action,
            v$,
            i18n,
            APP_URL,
            closeModal,
            pointeusesList,
            isRequestMember,
            hasPermission,
            isCaputre,
        };
    },
});
</script>
